import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { useSelector, useDispatch } from "react-redux";
import { setCondomiumTabValue } from "../../redux/slices/condominiumSlice";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CondominiumTabs = ({ mainTab, readings, consume, meter }) => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const condominiumTabValue = useSelector(
    (state) => state?.condominiumSlice?.condominiumTabValue
  );
  const handleChange = (event, newValue) => {
    dispatch(setCondomiumTabValue(newValue));
  };

  return (
    <Box sx={{ width: "100%", ml: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={condominiumTabValue}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={t("info")} {...a11yProps(0)} />
          <Tab label={t("radings_tab")} {...a11yProps(1)} />
          <Tab label={t("consume_tab")} {...a11yProps(2)} />
          <Tab label={t("meter_tab")} {...a11yProps(3)} disabled />
        </Tabs>
      </Box>
      <TabPanel value={condominiumTabValue} index={0}>
        {mainTab}
      </TabPanel>
      <TabPanel value={condominiumTabValue} index={1}>
        {readings}
      </TabPanel>
      <TabPanel value={condominiumTabValue} index={2}>
        {consume}
      </TabPanel>
      <TabPanel value={condominiumTabValue} index={3}>
        {meter}
      </TabPanel>
    </Box>
  );
};
export default CondominiumTabs;
